import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const ErrorPage = Scrivito.provideObjClass("ErrorPage", {
  attributes: {
    ...defaultPageAttributes,
    ...metadataAttributes,
  },
});

export default ErrorPage;
